const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEmptyTable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 70,
    viewBox: "0 0 64 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.2426 34.1543V69.2428L6.29797 66.5437V42.3188L27.3806 41.0162L34.2426 34.1543Z",
    fill: "#ADC4FF",
    style: {
      fill: "#ADC4FF",
      fill: "color(display-p3 0.6800 0.7700 1.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.1219 64.0593C19.0816 64.0593 19.0548 64.0593 19.0145 64.0593L10.9708 63.2804C10.3531 63.2267 9.89657 62.6761 9.96371 62.0584C10.0174 61.4407 10.5814 60.9976 11.1857 61.0513L19.2293 61.8301C19.847 61.8838 20.3036 62.4344 20.2365 63.0521C20.1828 63.6295 19.6859 64.0593 19.1219 64.0593Z",
    fill: "#D1F3FF",
    style: {
      fill: "#D1F3FF",
      fill: "color(display-p3 0.8200 0.9524 1.0000)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.8785 59.0101C14.8382 59.0101 14.8114 59.0101 14.7711 59.0101L10.9708 58.6341C10.3531 58.5804 9.89657 58.0298 9.96371 57.4121C10.0174 56.7944 10.5814 56.3379 11.1857 56.405L14.9859 56.7676C15.6037 56.8213 16.0602 57.3718 15.9931 57.9896C15.9394 58.567 15.4559 59.0101 14.8785 59.0101Z",
    fill: "#D1F3FF",
    style: {
      fill: "#D1F3FF",
      fill: "color(display-p3 0.8200 0.9524 1.0000)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M57.3529 41.6608V53.075C56.9366 53.0078 56.5069 52.9676 56.0638 52.9676C51.6727 52.9676 48.1141 56.5261 48.1141 60.9172C48.1141 63.5089 49.3496 65.8052 51.2698 67.2554L34.2426 69.2428V34.1543L40.6211 40.5328C46.2073 40.9088 51.7801 41.2982 57.3529 41.6608Z",
    fill: "#88ACFF",
    style: {
      fill: "#88ACFF",
      fill: "color(display-p3 0.5333 0.6738 1.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M34.2426 34.1543L27.3806 41.0162L6.29794 42.3188L0 42.7082L6.29794 36.4103L34.2426 34.1543Z",
    fill: "#76A0D9",
    style: {
      fill: "#76A0D9",
      fill: "color(display-p3 0.4646 0.6258 0.8499)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M62.9526 42.0368C61.086 41.9159 59.2195 41.7951 57.3529 41.6608C51.7801 41.2982 46.1939 40.9088 40.6211 40.5328L34.2426 34.1543L57.3529 36.464C59.2195 38.3171 61.086 40.1837 62.9526 42.0368Z",
    fill: "#76A0D9",
    style: {
      fill: "#76A0D9",
      fill: "color(display-p3 0.4646 0.6258 0.8499)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M31.8519 0.985848L34.269 5.8738C34.3361 5.99466 34.4436 6.08866 34.5778 6.10209L39.9761 6.88094C40.3118 6.93465 40.4595 7.35093 40.2044 7.59265L36.2967 11.4063C36.2027 11.5003 36.149 11.6346 36.1758 11.7823L37.1024 17.1537C37.1561 17.4894 36.807 17.758 36.4981 17.5968L31.6773 15.0589C31.5564 14.9917 31.4087 14.9917 31.2879 15.0589L26.4671 17.5968C26.1582 17.758 25.8091 17.5028 25.8628 17.1537L26.7893 11.7823C26.8162 11.648 26.7625 11.5138 26.6685 11.4063L22.7474 7.60607C22.5057 7.36436 22.6399 6.94808 22.9757 6.89437L28.3739 6.11552C28.5082 6.10209 28.629 6.00809 28.6827 5.88723L31.0999 0.999277C31.261 0.676994 31.6907 0.676994 31.8519 0.985848Z",
    fill: "#1859FF",
    style: {
      fill: "#1859FF",
      fill: "color(display-p3 0.0941 0.3490 1.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M12.2331 9.33826L13.6431 12.1717C13.6834 12.2388 13.7505 12.2925 13.8311 12.306L16.9599 12.7625C17.1613 12.7894 17.2419 13.0311 17.0942 13.1788L14.8113 15.3676C14.7576 15.4214 14.7308 15.5019 14.7442 15.5825L15.2813 18.6979C15.3216 18.8993 15.1068 19.047 14.9322 18.953L12.1391 17.4893C12.0719 17.449 11.9779 17.449 11.9108 17.4893L9.11768 18.953C8.94311 19.047 8.72825 18.8993 8.76854 18.6979L9.30568 15.5825C9.3191 15.5019 9.29225 15.4214 9.23853 15.3676L6.96913 13.1654C6.82141 13.0311 6.90198 12.7759 7.10341 12.7491L10.2188 12.306C10.2994 12.2925 10.3665 12.2388 10.4068 12.1717L11.8034 9.33826C11.8974 9.15027 12.1525 9.15027 12.2331 9.33826Z",
    fill: "#1859FF",
    style: {
      fill: "#1859FF",
      fill: "color(display-p3 0.0941 0.3490 1.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M51.1487 9.33826L52.5453 12.1717C52.5856 12.2388 52.6527 12.2925 52.7333 12.306L55.8621 12.7625C56.0635 12.7894 56.1441 13.0311 55.9964 13.1788L53.7404 15.3811C53.6867 15.4348 53.6598 15.5154 53.6733 15.5959L54.2104 18.7113C54.2507 18.9128 54.0358 19.0605 53.8613 18.9665L51.0682 17.5028C51.001 17.4625 50.907 17.4625 50.8399 17.5028L48.0468 18.9665C47.8722 19.0605 47.6573 18.9128 47.6976 18.7113L48.2348 15.5959C48.2482 15.5154 48.2213 15.4348 48.1676 15.3811L45.9116 13.1788C45.7639 13.0445 45.8445 12.7894 46.0459 12.7625L49.1747 12.306C49.2553 12.2925 49.3225 12.2388 49.3627 12.1717L50.7593 9.33826C50.7996 9.15027 51.0547 9.15027 51.1487 9.33826Z",
    fill: "#1859FF",
    style: {
      fill: "#1859FF",
      fill: "color(display-p3 0.0941 0.3490 1.0000)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M31.4763 31.1868C30.8585 31.1868 30.3617 30.6899 30.3617 30.0722V22.5657C30.3617 21.948 30.8585 21.4512 31.4763 21.4512C32.094 21.4512 32.5908 21.948 32.5908 22.5657V30.0722C32.5908 30.6765 32.094 31.1868 31.4763 31.1868Z",
    fill: "#70C9E9",
    style: {
      fill: "#70C9E9",
      fill: "color(display-p3 0.4392 0.7882 0.9137)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M46.9593 32.65C46.8116 32.65 46.6505 32.6232 46.5028 32.556C45.9388 32.3009 45.6836 31.6429 45.9253 31.0789L49.5913 22.7935C49.8464 22.2295 50.5044 21.9744 51.0684 22.2161C51.6324 22.4712 51.8876 23.1292 51.6458 23.6932L47.9799 31.992C47.7919 32.4083 47.389 32.65 46.9593 32.65Z",
    fill: "#70C9E9",
    style: {
      fill: "#70C9E9",
      fill: "color(display-p3 0.4392 0.7882 0.9137)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M39.8961 32.0868C39.7886 32.0868 39.6946 32.0733 39.5872 32.0465C38.9963 31.8719 38.6472 31.2542 38.8218 30.6634L41.9909 19.6386C42.1655 19.0477 42.7832 18.6986 43.374 18.8732C43.9649 19.0477 44.314 19.6654 44.1394 20.2563L40.9703 31.2811C40.836 31.7645 40.3929 32.0868 39.8961 32.0868Z",
    fill: "#70C9E9",
    style: {
      fill: "#70C9E9",
      fill: "color(display-p3 0.4392 0.7882 0.9137)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M23.2851 32.1798C22.8017 32.1798 22.3451 31.8575 22.2109 31.3741L19.1223 20.6313C18.9477 20.0404 19.2969 19.4093 19.8877 19.2482C20.4786 19.0736 21.1097 19.4227 21.2709 20.0136L24.3594 30.7564C24.534 31.3472 24.1848 31.9783 23.594 32.1395C23.5 32.1663 23.3926 32.1798 23.2851 32.1798Z",
    fill: "#70C9E9",
    style: {
      fill: "#70C9E9",
      fill: "color(display-p3 0.4392 0.7882 0.9137)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M15.9931 32.6507C15.5634 32.6507 15.1471 32.3955 14.9726 31.9792L11.3737 23.8416C11.1186 23.2776 11.3737 22.6196 11.9512 22.3645C12.5152 22.1093 13.1732 22.3645 13.4283 22.9419L17.0271 31.0795C17.2823 31.6435 17.0271 32.3015 16.4497 32.5567C16.302 32.6238 16.1543 32.6507 15.9931 32.6507Z",
    fill: "#70C9E9",
    style: {
      fill: "#70C9E9",
      fill: "color(display-p3 0.4392 0.7882 0.9137)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M62.2812 65.8448C60.8309 67.6711 58.5883 68.8528 56.0638 68.8528C54.2644 68.8528 52.6127 68.2485 51.2833 67.2548C49.363 65.8045 48.1141 63.5083 48.1141 60.9166C48.1141 58.392 49.2824 56.1495 51.1221 54.6992C50.0344 56.0555 49.3898 57.7743 49.3898 59.6275C49.3898 62.2191 50.6253 64.5154 52.5455 65.9657C53.8749 66.9728 55.5401 67.5637 57.3261 67.5637C59.206 67.5637 60.9249 66.9191 62.2812 65.8448Z",
    fill: "#58B4D9",
    style: {
      fill: "#58B4D9",
      fill: "color(display-p3 0.3451 0.7059 0.8510)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M64 60.9164C64 62.783 63.3555 64.5018 62.2812 65.8447C60.9249 66.919 59.2061 67.5635 57.353 67.5635C55.5535 67.5635 53.9019 66.9592 52.5724 65.9655C50.6522 64.5153 49.4167 62.219 49.4167 59.6273C49.4167 57.7608 50.0613 56.0419 51.149 54.6991C52.5053 53.6114 54.2241 52.9668 56.0773 52.9668C56.5204 52.9668 56.9501 53.0071 57.3664 53.0742C61.1264 53.6919 64 56.9685 64 60.9164Z",
    fill: "#70C9E9",
    style: {
      fill: "#70C9E9",
      fill: "color(display-p3 0.4392 0.7882 0.9137)",
      fillOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmptyTable);
export default __webpack_public_path__ + "static/media/icon_empty_table.9c78fcba3e2723c79242db8f3e5b3b2c.svg";
export { ForwardRef as ReactComponent };